import './service.scss';
import React, { Component } from 'react';
import {getComponentIcon, getComponentStateInfo} from '../../../helpers/componentHelper';
import componentState from '../../../enums/componentState';

class ServiceComponent extends Component {
  renderIcon() {
    const iconSrc = getComponentIcon(this.props.componentType);
    return ( <img className="component-icon" src={iconSrc} alt="service icon"/>);
  }

  render() {
    const stateInfo = getComponentStateInfo(this.props.state);
    return (
      <div style={{marginBottom: '24px'}}>
        <div className="component">
          <div>
            {this.renderIcon()}
            <div className="component-title">
              <span>{this.props.name}</span>
            </div>
          </div>
          <div style={{color:stateInfo.color}}>
            <span>{stateInfo.description}</span>
          </div>
        </div>
        { this.props.state != componentState.operational && this.props.statusMessage ? 
          <span style={{marginLeft:'40px'}}>{this.props.statusMessage}</span> 
          : null }
      </div>
    );
  }
}

export default ServiceComponent;